import { VALUE_SCAN_PURPOSES, type ValueScanPurpose } from '@/shared/camera/value-scan-purposes';
import { normalizeMeterIdentifier } from '@/shared/meter-identification';

const obisPattern = /\b\d+(?:-\d+)?\.\d+(?:\.\d+)?\b/;
const numberPattern = /\b\d+(?:[.,]\d+)?\b/;
const unitPattern = /\b(kWh|MWh|GJ|MJ|m3|m³)\b/i;

export function normalizeValueForPurpose(rawValue: string, purpose: ValueScanPurpose) {
  const text = rawValue.trim();

  if (!text) {
    return '';
  }

  switch (purpose) {
    case VALUE_SCAN_PURPOSES.apiKey:
      return normalizeApiKey(text);
    case VALUE_SCAN_PURPOSES.devEui:
      return text.replace(/[\s:_-]/g, '').toUpperCase();
    case VALUE_SCAN_PURPOSES.meterLookup:
      return normalizeMeterIdentifier(readApiKeyFromUrl(text) || text).normalizedValue;
    case VALUE_SCAN_PURPOSES.registerCounter:
      return text.match(numberPattern)?.[0].replace(',', '.') ?? '';
    case VALUE_SCAN_PURPOSES.registerObis:
      return text.match(obisPattern)?.[0] ?? '';
    case VALUE_SCAN_PURPOSES.registerUnit:
      return normalizeUnit(text.match(unitPattern)?.[0] ?? text);
    case VALUE_SCAN_PURPOSES.serial:
      return normalizeSerial(text);
  }
}

function normalizeApiKey(value: string) {
  const parsedFromUrl = readApiKeyFromUrl(value);

  if (parsedFromUrl) {
    return parsedFromUrl;
  }

  return value.replace(/^api\s*key\s*[:#-]?\s*/i, '').trim();
}

function readApiKeyFromUrl(value: string) {
  try {
    const url = new URL(value);

    return url.searchParams.get('apiKey') ?? '';
  } catch {
    return '';
  }
}

function normalizeSerial(value: string) {
  return value
    .replace(/^serial(?:\s*number)?\s*[:#-]?\s*/i, '')
    .replace(/\s+/g, '')
    .toUpperCase();
}

function normalizeUnit(value: string) {
  if (value.toLowerCase() === 'm³') {
    return 'm3';
  }

  return value;
}
